import { render, staticRenderFns } from "./MensajeMostrarResultado.vue?vue&type=template&id=262375be&"
import script from "./MensajeMostrarResultado.vue?vue&type=script&lang=ts&"
export * from "./MensajeMostrarResultado.vue?vue&type=script&lang=ts&"
import style0 from "./MensajeMostrarResultado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports